<template>
  <div class="navbar navbar-expand-md navbar-dark navbar-48 ml-0 pl-3">
    <!-- <div class="navbar-brand"> -->
    <div class="d-flex justify-content-between align-items-center navbar-brand ml-0 pl-0">
      <router-link
        to="/chat/all"
        class="d-inline-block"
      >
        <img
          :src="$storeIndex.getLogoGlobalSvgAssets('GoChat-logo-sm')"
          alt=""
          class="logo-sm logo-gochat-beta-sm"
          @mouseenter="showLeftMenu()"
          @mouseleave="hideLeftMenu()"
        >
        <img
          :src="$storeIndex.getLogoGlobalSvgAssets('GoChat-logo-sm')"
          alt=""
          class="logo-lg logo-gochat-beta-sm"
          @mouseenter="showLeftMenu()"
          @mouseleave="hideLeftMenu()"
        >
      </router-link>
      <!-- <a href="javascript:void(0);" class=" hamberger
              navbar-nav-link
              sidebar-control sidebar-main-toggle
              d-none d-md-block
            ">
            <i class="icon-paragraph-justify3"></i>
        </a> -->
    </div>

    <!-- <div class="d-md-none">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-mobile">
            <i class="icon-tree5"></i>
        </button>
        <button class="navbar-toggler sidebar-mobile-main-toggle" type="button">
            <i class="icon-paragraph-justify3"></i>
        </button>
    </div> -->

    <!-- Toggle เสียงแจ้งเตือนแบบเร็ว — วางนอก .navbar-collapse เพื่อให้ยังเห็นบนจอเล็กกว่า 768px
         และอยู่นอกลิงก์ดรอปดาวน์บัญชี กดแล้วเมนูบัญชีจะได้ไม่เด้งตาม -->
    <div class="d-flex align-items-center ml-auto">
      <a
        class="d-flex align-items-center justify-content-center navbar-nav-link"
        style="cursor: pointer;"
        role="button"
        tabindex="0"
        :aria-label="$t('notification sound')"
        :aria-pressed="notificationSoundEnabled ? 'true' : 'false'"
        :title="$t('notification sound')"
        @click="toggleNotificationSound"
        @keydown.enter.prevent="onNotificationSoundKeydown"
        @keydown.space.prevent="onNotificationSoundKeydown"
      >
        <i
          :class="notificationSoundEnabled ? 'fas fa-bell' : 'fas fa-bell-slash'"
          class="d-flex justify-content-center align-items-center"
          style="font-size: 1rem !important; width: 1.25rem; height: 1.25rem;"
          :style="{ color: notificationSoundEnabled ? '#64BD63' : '' }"
        />
      </a>
    </div>

    <div
      class="collapse navbar-collapse justify-content-end flex-grow-0"
      id="navbar-mobile"
    >
      <!-- <ul class="navbar-nav">
            <li class="nav-item">
                <a href="javascript:void(0);" class="
              navbar-nav-link
              sidebar-control sidebar-main-toggle
              d-none d-md-block
            ">
                    <i class="icon-paragraph-justify3"></i>
                </a>
            </li>
        </ul> -->

      <!-- <Navbar /> -->
      <ul class="navbar-nav">
        <li class="nav-item dropdown">
          <a
            href="#"
            class="navbar-nav-link dropdown-toggle caret-0 d-flex flex-row align-items-center justify-content-center"
            data-toggle="dropdown"
          >
            <img
              :src="checkUnknowFBImage(merchant.logo)"
              @error="errorMerchantImage($event)"
              class="img-chat-receiver"
              contain
              alt=""
            >
            <div class="d-flex flex-column align-items-start justify-content-center ml-2">
              <span class="merchat-name-navbar">
                {{ $cookie.get("merchantName") || "-" }}
              </span>
              <span class="user-name-navbar">{{ user.first_name || "" }} {{ user.last_name || "" }}</span>
            </div>
            <img
              class="ml-2"
              src="@/assets/global_assets/images/angle-down-regular-9.svg"
            >
          </a>

          <div
            class="dropdown-menu dropdown-menu-right dropdown-content wmin-md-300"
            style="top: 54px;"
          >
            <!-- <div
              class="dropdown-content-header d-flex align-items-center justify-space-between"
              @click="logoutFunc()"
            >
              <span class="">{{ $t("Log out") }}</span>
              <i class="far fa-sign-out" />
            </div> -->
            <div class="dropdown-content-header d-flex flex-row align-items-center justify-content-start">
              <img
                :src="checkUnknowFBImage(user.image_profile)"
                @error="errorUserImage($event)"
                class="img-user-top"
                contain
                alt=""
              >
              <div class="d-flex flex-column align-items-start justify-content-center ml-2">
                <span class="user-name-top">
                  {{ user.first_name }} {{ user.last_name }}
                </span>
                <span class="user-email-top">{{ user.email }}</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <modal-disconnected-pages />
    <modal-unlink-pages />
    <ModalDeletionFBPages />
  </div>
</template>

<script>
import { localSave, localRead } from "@/store/lang";
import { mapGetters } from "vuex";
import { USER, MERCHANT } from "@/vuex-store/types";
import AuthApi from "@/services/auth.service";
import { mapActions } from "vuex";
import * as types from "@/vuex-store/types";
// import Navbar from './Navbar.vue'
import defaultMerchantImg from "@/assets/images/all-page.svg";
import defaultUserImg from "@/assets/global_assets/images/default-user.svg";
import Api from "@/services/endpoint/central.service";
import { formatTimestampToHumanDate, isSelectedConversation, unknowTomessage } from '@/vuex-store';
import moment from 'moment';
import { convertTimezone } from '@/plugins/convertTimezone';
import ModalDisconnectedPages from "@/components/modals/ModalDisconnectedPages.vue";
import ModalUnlinkPages from '@/components/modals/ModalUnlinkPages.vue';
import ModalDeletionFBPages from '@/components/modals/ModalDeletionFBPages.vue';
import notificationSound from "@/services/notificationSound";

export default {
  name: "TopMenu",
  data() {
    return {
      lang: localRead("local"),
      tenantName: "",
      userData: {
        name: "",
        role: "Administer",
      },
      localList: {
        th: "Thai",
        en: "English",
      },
      count: 0,
      filterChatType: "",
      notificationSoundEnabled: false,
      _soundUnsub: null,
    };
  },
  components: {
    // Navbar,
    ModalDisconnectedPages,
    ModalUnlinkPages,
    ModalDeletionFBPages,
  },
  mounted() {
    // sync สถานะปุ่มเสียงจาก localStorage + ฟัง event เพื่อ sync กับ toggle ในหน้า Settings (same-tab)
    this.notificationSoundEnabled = notificationSound.isEnabled();
    this._soundUnsub = notificationSound.onChange((state) => {
      this.notificationSoundEnabled = state;
    });
    if (!this.$cookie.get("centralToken") && window.location.pathname !== "/backoffice/login") {
      this.logoutFunc();
    }
    if (this.$store.state.backoffice) {
      delete this.$store.state.backoffice
    }
    this.filterChatType =
      this.$route.meta.title == "Messenger"
        ? "facebook"
        : this.$route.meta.title == "Direct Messenger"
        ? "instagram"
        : this.$route.meta.title == "Line"
        ? "line"
        : "";
    // this.$store.dispatch("anonymousMessageAction", [])
  },
  computed: {
    ...mapGetters({
      user: USER,
      merchant: MERCHANT,
    }),
    title() {
      return this.localList[this.lang];
    },
  },
  created() {
    this.fetchChannels();
    this.fetchDeletionLists();
    if (window.location.pathname !== "/settings/facebook-event-method") {
      this.$store.state.showedPageDisconnected = false;
      this.$store.state.showedPageUnlinked = false;
      this.$store.state.showedPageDeleted = false;
    }
  },
  beforeDestroy() {
    if (this._soundUnsub) this._soundUnsub();
  },
  methods: {
    toggleNotificationSound() {
      // สลับเสียง + persist ผ่าน service (service จะ emit event ให้ที่อื่น sync ตาม)
      this.notificationSoundEnabled = notificationSound.toggle();
    },
    onNotificationSoundKeydown(event) {
      // กดค้างแล้ว OS ยิง keydown ซ้ำรัว — ข้ามรอบที่เป็น auto-repeat ไม่ให้ toggle รัวและเสียงยืนยันดังถี่
      if (event && event.repeat) return;
      this.toggleNotificationSound();
    },
    ...mapActions({
      logout: types.LOGOUT,
    }),
    selectLang(lang) {
      localSave("local", lang);
      location.reload();
    },
    async fetchChannels() {
      /* use worldwide */
      let itemsDisconnected = [];
      let itemsPageUnlink = [];
      /* */

      try {
        const request = await Api.Chat.getPages({
          merchant_id: this.user.merchant_id,
          integration_name: "",
        });

        if(request.status != 200) {
          throw ({message : "get page status failed"}) 
        }
        const pageIds = request.data.data.map(item => item.platform_page_id);
        const pages = [
          this.filterChatType
            ? {
                id: "allpage",
                name: this.$t("All"),
                page_id: "",
                integration_name: "",
                merchant_id: this.user.merchant_id,
                logo: null,
                platform_page_id: null,
                is_connected: false,
                access_token_expire_date: "",
              }
            : {
                id: "allpage",
                name: this.$t("All Channels"),
                page_id: "",
                integration_name: "",
                merchant_id: this.user.merchant_id,
                logo: null,
                platform_page_id: null,
                is_connected: false,
                access_token_expire_date: "",
              },
        ];
        for (const page of request.data.data) {
          // this.$store.dispatch('websocket/initializeWebSocketForChannel', page.platform_page_id);
          let toDay = new Date();
          let startDate = moment(convertTimezone.utcToLocal(toDay));
          let endDate = moment(convertTimezone.utcToLocal(page.access_token_expire_date));
          let duration = moment.duration(endDate.diff(startDate));
          let daysEnds = duration.asDays();
          let planEndsAt = Math.round(daysEnds);
          let status = "";
          // console.log("page: ", page.access_token_expire_date, planEndsAt)
          status = !page.is_connected ? "disconnect" : (planEndsAt >= 1 && planEndsAt <=7 && page.access_token_expire_date) ? "nearby" : (planEndsAt < 1 && page.access_token_expire_date) ? "expired" : "connected";
          if (page.id !== "allpage" && status == "disconnect") {
            itemsDisconnected.push({
              name: page.name,
              page_id: page.page_id,
              integration_name: page.integration_name,
              logo: page.profile_image ? page.profile_image : null,
            })
          } else if (status == "nearby") {
            itemsDisconnected.push({
              name: page.name,
              page_id: page.page_id,
              integration_name: page.integration_name,
              logo: page.profile_image ? page.profile_image : null,
            })
          } else if (status == "expired") {
            itemsDisconnected.push({
              name: page.name,
              page_id: page.page_id,
              integration_name: page.integration_name,
              logo: page.profile_image ? page.profile_image : null,
            })
          }

          if (page.integration_name == "facebook" && page.fb_conversion_dataset_status == "unlink" && (page.fb_conversion_settings && page.fb_conversion_settings.event_type == "DataSet")) {
            itemsPageUnlink.push({
              name: page.name,
              page_id: page.page_id,
              logo: page.profile_image ? page.profile_image : null,
            })
          }

          if (this.filterChatType && this.filterChatType == page.integration_name)
            pages.push({
              ...page,
              id: page._id,
              name: page.name,
              page_id: page.page_id,
              integration_name: page.integration_name,
              logo: page.profile_image ? page.profile_image : null,
              platform_page_id: page.platform_page_id ? page.platform_page_id : "",
              page_integrate_status: status,
              is_connected: page.is_connected,
              access_token_expire_date: page.access_token_expire_date,
            });
          else if (!this.filterChatType)
            pages.push({
              ...page,
              id: page._id,
              name: page.name,
              page_id: page.page_id,
              integration_name: page.integration_name,
              logo: page.profile_image ? page.profile_image : null,
              platform_page_id: page.platform_page_id ? page.platform_page_id : "",
              page_integrate_status: status,
              is_connected: page.is_connected,
              access_token_expire_date: page.access_token_expire_date,
            });
        }

        this.$store.dispatch('websocket/initializeWebSocketChannels', {
          pageIds: pageIds,
          userId : this.user._id || this.user.user_id,
          merchantId: this.user.merchant_id
        });

        // this.$store.state.allPage = pages;
        this.$store.state.itemsPageDisconnected = itemsDisconnected;
        this.$store.state.itemsPageUnlink = itemsPageUnlink;
        this.$store.dispatch("setChannelsAction", pages)
        if (this.$store.state.allPage) {
          delete this.$store.state.allPage
        }
        if (this.$store.state.auth && this.$store.state.auth.allPage) {
          delete this.$store.state.auth.allPage
        }
        if (this.$store.state.newConversations) {
          delete this.$store.state.newConversations
        }
        if (this.$store.state.backoffice) {
          delete this.$store.state.backoffice
        }
        if (this.$store.state.adminTypingAllItems) {
          delete this.$store.state.adminTypingAllItems
        }
        if (this.$store.state.adminTypingItems) {
          delete this.$store.state.adminTypingItems
        }
        this.$store.dispatch("clearReadedMessageAction", null)
        this.$store.dispatch("setMessageTypingAction", [])
        this.$store.dispatch("setChatUpdateAction", [])
        var clearedUnknownymousMsg = [];
        this.$store.state.anonymousMessage.map(msg => {
          const findPageId = pages.filter(ch => ch.page_id == msg.page_id)
          if (msg.send_cnt > 0 && msg.direction == "right" && !msg.send_success && findPageId.length) clearedUnknownymousMsg.push(msg)
        })
        this.$store.dispatch("anonymousMessageAction", clearedUnknownymousMsg)
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.$router.push({ name: 'Access Denied' });
        } else if (error.response && error.response.data && error.response.data.message == "token has expired") {
          this.$storeIndex.gotoGoSaas(this);
        }
        console.error(error.message)
      }
    },
    async fetchDeletionLists() {
      let page = 1;
      let limit = 10;
      
      this.$store.state.callAPIDeletionPage = true;
      this.$store.state.dataPageDeleted = null;
      this.$store.state.itemsPageDeleted = [];
      this.$store.state.tablePageDeleted = null;

      try {
        const request = await Api.Chat.getDeletionList(page, limit);

        if(request.status != 200) {
          throw ({message : "get deletion list failed"}) 
        }

        if (request.status == 200) {
          if (request.data && request.data.data && request.data.data.length) {
            this.$store.state.dataPageDeleted = request.data;
            this.$store.state.itemsPageDeleted = request.data.data;

            let data = this.$storeIndex.mutations.vueTableFormatJson(request);
            data = {
              data: data.data,
              current_page: request.data.currentPage || 1,
              from: request.data.from || 1,
              last_page: request.data.totalPages || 1,
              per_page: 10,
              prev: request.data.currentPage == 1 ? null : request.data.currentPage - 1,
              total: request.data.totalResults,
            }

            this.$store.state.tablePageDeleted = data;
          }
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.message == "token has expired") this.$storeIndex.gotoGoSaas(this);
        console.error(error.message)
      }
    },
    async logoutFunc() {
      await AuthApi.logOut();
      this.$cookie.remove("centralToken");
      this.$cookie.remove("callbackUrl");
      this.$cookie.remove("merchantName");
      this.$cookie.remove("latestProducts");
      this.logout();
      // setTimeout(() => {
      this.$router.push("/login").catch(() => {});
      // }, 3000);
    },
    showLeftMenu() {
      this.$emit('showMenu')
    },
    hideLeftMenu() {
      this.$emit('hideMenu')
    },
    errorMerchantImage(e) {
      // console.log(e)
      e.target.src = defaultMerchantImg
    },
    errorUserImage(e) {
      // console.log(e)
      e.target.src = defaultUserImg
    },
    checkUnknowFBImage(srcImg) {
      let findString = "";
      if (srcImg) findString = srcImg.includes("84628273_176159830277856_972693363922829312_n.jpg");
      return findString ? defaultUserImg : this.changePicPath(srcImg);
    },
    changePicPath(imgName) {
      const stringV1 = "v1/pic";
      const stringV2 = "v2/pic";
      if (imgName.includes(stringV1)) {
        return imgName.replace(stringV1, stringV2);
      } else {
        return imgName;
      }
    },
  },
};
</script>

<style></style>


// WEBPACK FOOTER //
// src/layouts/web/template/TopMenu.vue